export const Z_INDEX = {
    DROPDOWN: 1300,
    MODAL: 1400,
    TOOLTIP: 1500,
    TOAST: 1600,
    OVERLAY: 1700,
} as const; 